import type { ConstraintType, ProductStatus, ProductType, SelectionRule } from "../../../../types/adminBilling";

// L-15: Regex pattern for featureCode Value Object format
// Valid prefixes: module, limit, scope, config (matches backend VO)
export const FEATURE_CODE_PATTERN = /^(module|limit|scope|config):[a-z][a-z0-9_]*(:[a-z][a-z0-9_]*)*$/;

export const PRODUCT_STATUS_LABELS: Record<ProductStatus, string> = {
  DRAFT: "Szkic",
  ACTIVE: "Aktywny",
  ARCHIVED: "Zarchiwizowany",
};

export const PRODUCT_STATUS_CLASSES: Record<ProductStatus, string> = {
  DRAFT: "bg-yellow-100 text-yellow-800",
  ACTIVE: "bg-green-100 text-green-800",
  ARCHIVED: "bg-neutral-100 text-neutral-500",
};

export const PRODUCT_TYPE_LABELS: Record<ProductType, string> = {
  LEAF: "Produkt",
  PACKAGE: "Pakiet",
};

export const PRODUCT_TYPE_CLASSES: Record<ProductType, string> = {
  LEAF: "bg-blue-100 text-blue-800",
  PACKAGE: "bg-purple-100 text-purple-800",
};

export const SELECTION_RULE_LABELS: Record<SelectionRule, string> = {
  ALL: "Wszystkie",
  EXACTLY_ONE: "Dokładnie jeden",
  AT_LEAST_ONE: "Co najmniej jeden",
  AT_MOST_ONE: "Co najwyżej jeden",
  OPTIONAL: "Opcjonalny",
};

export const ALL_SELECTION_RULES: SelectionRule[] = [
  "ALL",
  "EXACTLY_ONE",
  "AT_LEAST_ONE",
  "AT_MOST_ONE",
  "OPTIONAL",
];

// Constraint types
export const CONSTRAINT_TYPE_LABELS: Record<ConstraintType, string> = {
  BOOLEAN: "Wartość logiczna",
  ALLOWED_VALUES: "Lista dozwolonych wartości",
  NUMERIC_RANGE: "Zakres liczbowy (całkowite)",
  DECIMAL_RANGE: "Zakres liczbowy (dziesiętne)",
  DATE_RANGE: "Zakres dat",
  REGEX: "Wzorzec (regex)",
  UNCONSTRAINED: "Bez ograniczeń",
};

export const ALL_CONSTRAINT_TYPES: ConstraintType[] = [
  "BOOLEAN",
  "ALLOWED_VALUES",
  "NUMERIC_RANGE",
  "DECIMAL_RANGE",
  "DATE_RANGE",
  "REGEX",
  "UNCONSTRAINED",
];

/** Default constraintConfig per constraint type */
export const DEFAULT_CONSTRAINT_CONFIGS: Record<ConstraintType, Record<string, unknown>> = {
  BOOLEAN: {},
  ALLOWED_VALUES: { values: [] },
  NUMERIC_RANGE: { min: 0, max: 100 },
  DECIMAL_RANGE: { min: 0, max: 100 },
  DATE_RANGE: {},
  REGEX: { pattern: "" },
  UNCONSTRAINED: {},
};

// Package structure limits
export const MAX_SETS_PER_PACKAGE = 10;
export const MAX_PRODUCTS_PER_SET = 50;
